import React from 'react';
import { bool, func, node, shape, string } from 'prop-types';
import { Box, CircularProgress, IconButton, Typography } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const scrollbarStyles = {
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  flex: 1,
  minHeight: 0,
  overflowX: 'hidden',
  overflowY: 'auto',
  scrollbarWidth: 'none',
};

const DrawerLayoutWrapper = ({ buttons, children, isLoading, onHeaderButtonClick, sx, title }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      ...sx,
    }}
  >
    <Box
      alignItems="center"
      bgcolor="surface.white"
      boxShadow={1}
      display="flex"
      flexShrink={0}
      height="64px"
      justifyContent="space-between"
      paddingLeft={2.5}
      paddingTop={1}
      position="sticky"
      top={0}
      zIndex={1}
    >
      <Typography variant="h6">{title}</Typography>
      <IconButton
        onClick={onHeaderButtonClick}
        size="large"
        sx={{
          color: 'secondary.medium',
          marginRight: 2,
        }}
      >
        <CloseRoundedIcon className="css-heap-redact" />
      </IconButton>
    </Box>
    {/* simple overlay without any additional library */}
    {isLoading && (
      <Box
        bgcolor="rgba(0, 0, 0, 0.3)"
        height="calc(100% - 146px)"
        position="absolute"
        top="66px"
        width="100%"
        zIndex={3}
      >
        <CircularProgress
          sx={{
            left: 'calc(50% - 20px)',
            position: 'absolute',
            top: 'calc(50% - 20px)',
          }}
        />
      </Box>
    )}
    <Box className="DrawerLayoutWrapper-inner" sx={scrollbarStyles}>
      {children}
    </Box>
    {buttons && (
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: 'surface.white',
          borderTop: '1px solid',
          borderTopColor: 'graphic.light',
          bottom: 0,
          boxShadow: 0,
          display: 'flex',
          gridGap: 2,
          height: 68,
          justifyContent: 'center',
          position: 'sticky',
          px: 2,
          py: 3,
          width: '100%',
          zIndex: 1,
        }}
      >
        {buttons}
      </Box>
    )}
  </Box>
);

DrawerLayoutWrapper.propTypes = {
  buttons: node,
  children: node,
  isLoading: bool,
  onHeaderButtonClick: func.isRequired,
  sx: shape({}),
  title: string.isRequired,
};

DrawerLayoutWrapper.defaultProps = {
  buttons: null,
  children: null,
  isLoading: false,
  sx: null,
};

export default DrawerLayoutWrapper;
